import { categories } from "@/mocks/categories";
import CategoryBadge from "@/components/base/CategoryBadge";

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-100/50">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-3">
            探索分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            涵盖企业内幕、金融黑幕、娱乐揭秘等多个领域，找到你关心的真相
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {categories.map((cat) => (
            <CategoryBadge key={cat.slug} category={cat} />
          ))}
        </div>
      </div>
    </section>
  );
}